import IconButton from "..";
import { CheckIcon } from "@/constant/imagePath";

const ChecklistButton = ({
  icon = CheckIcon,
  borderColor = "#05A16D",
  fromColor = "#19C38B",
  toColor = "#088D96",
  onClick = null,
  tooltipText = "Save",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default ChecklistButton;
